import React, { useMemo } from 'react';
import { numberornone } from '../../utils/textFormat';

const CasualtiesComponent = ({ casualties }) => {
  const total = useMemo(
    () =>
      casualties
        ? casualties.kia.enemy +
          casualties.kia.neutral +
          casualties.kia.friendly +
          casualties.wia.enemy +
          casualties.wia.neutral +
          casualties.wia.friendly
        : 0,
    [casualties]
  );

  if (casualties) {
    return (
      <>
        <tr>
          <th>Casualties</th>
          <td>{numberornone(total)}</td>
        </tr>
        <tr>
          <th>
            KIA <span className="friendly">Friendly</span>
          </th>
          <td>{numberornone(casualties.kia.friendly)}</td>
        </tr>
        <tr>
          <th>
            WIA <span className="friendly">Friendly</span>
          </th>
          <td>{numberornone(casualties.wia.friendly)}</td>
        </tr>
        <tr>
          <th>
            KIA <span className="neutral">Neutral</span>
          </th>
          <td>{numberornone(casualties.kia.neutral)}</td>
        </tr>
        <tr>
          <th>
            WIA <span className="neutral">Neutral</span>
          </th>
          <td>{numberornone(casualties.wia.neutral)}</td>
        </tr>
        <tr>
          <th>
            KIA <span className="enemy">Enemy</span>
          </th>
          <td>{numberornone(casualties.kia.enemy)}</td>
        </tr>
        <tr>
          <th>
            WIA <span className="enemy">Enemy</span>
          </th>
          <td>{numberornone(casualties.wia.enemy)}</td>
        </tr>
      </>
    );
  }

  return null;
};

export default CasualtiesComponent;
